import ProjectVariation from "../types/ProjectVariation";
import ProjectVariationLink from "../types/ProjectVariationLink";
import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postProjectVariation = (
    token: string,
    backend: string,
    body: ProjectVariation
) => {
    return fetch(
        `${getApiUrl(backend)}project_variations`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        }
    );
};

export default postProjectVariation;
